import * as React from 'react';
import { useState, useEffect, useCallback } from "react";
import PropTypes from 'prop-types';

import SaveIcon from '@mui/icons-material/Save';

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

import { TextField, Button, FormControl, makeStyles } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";

import RecipeService from '../../services/recipe.service.js';
import BatchDataService from '../../services/batchdata.service.js';
import AuditTrailViewService from '../../services/audittrailview.service.js';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

// Function to create auditTrailData
const createAuditTrailData = (oldValues, newValues, groupName, activity, activityType, userName, role, remark, eventStatus) => {
  
  let auditTrailData = [];
  // Get the keys of the oldValues
  const keys1 = Object.keys(oldValues);
  //console.log(keys1)
  //console.log(Object.keys(newValues))
  //console.log(keys1.length, Object.keys(newValues).length)
  // Check if the number of keys is the same
  if (keys1.length !== Object.keys(newValues).length) {
    return auditTrailData;
  }else{
    // Iterate over the keys of the oldValues
    for (let key of keys1) {
      //console.log(key, oldValues[key], newValues[key]);
      
      let activityStatus = activity;
      // modify Activity if event is enabled else activity will be deafualt value received form audittrail config collection
      if(eventStatus === "Enabled"){
        if(key === "GroupName"){
          activityStatus = `Created new recipe group - ${groupName}.`;
          auditTrailData.push({TimeStamp: new Date(), Activity: activityStatus, ActivityType: activityType, UserName: userName, Role: role, Remark: remark, EventStatus: eventStatus});
        }
      } else{
        auditTrailData.push({TimeStamp: new Date(), Activity: activityStatus, ActivityType: activityType, UserName: userName, Role: role, Remark: remark, EventStatus: eventStatus});
      }  
      
    }
    return auditTrailData;
  }

  

};

function SaveChangesDialog(props) {
  const [open, setOpen] = useState(false);

  const widgetConfigData = [{
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "1",
    "ParameterName": "Channel1",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "Enabled",
    "Min": "Enabled",
    "Max": "Enabled",
    "Avg": "Enabled",
    "MKT": "Enabled",
    "AssignedTag":"",
    "Description": "Channel-1",
    "Description1": "Description-1",
    "Description2": "Description-2",
    "Value": "na",
    "Count": "Disabled",
    "Median": "Disabled",
    "Mode": "Disabled",
    "StdDev": "Disabled",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "2",
    "ParameterName": "Channel2",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "Enabled",
    "Min": "Enabled",
    "Max": "Enabled",
    "Avg": "Enabled",
    "MKT": "Enabled",
    "AssignedTag":"",
    "Description": "Channel-2",
    "Description1": "Description-1",
    "Description2": "Description-2",
    "Value": "na",
    "Count": "Disabled",
    "Median": "Disabled",
    "Mode": "Disabled",
    "StdDev": "Disabled",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "3",
    "ParameterName": "Channel3",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "Enabled",
    "Min": "Enabled",
    "Max": "Enabled",
    "Avg": "Enabled",
    "MKT": "Enabled",
    "AssignedTag":"",
    "Description": "Channel-3",
    "Description1": "Description-1",
    "Description2": "Description-2",
    "Value": "na",
    "Count": "Disabled",
    "Median": "Disabled",
    "Mode": "Disabled",
    "StdDev": "Disabled",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "4",
    "ParameterName": "Channel4",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "Enabled",
    "Min": "Enabled",
    "Max": "Enabled",
    "Avg": "Enabled",
    "MKT": "Enabled",
    "AssignedTag":"",
    "Description": "Channel-4",
    "Description1": "Description-1",
    "Description2": "Description-2",
    "Value": "na",
    "Count": "Disabled",
    "Median": "Disabled",
    "Mode": "Disabled",
    "StdDev": "Disabled",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "5",
    "ParameterName": "Channel5",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "Enabled",
    "Min": "Enabled",
    "Max": "Enabled",
    "Avg": "Enabled",
    "MKT": "Enabled",
    "AssignedTag":"",
    "Description": "Channel-5",
    "Description1": "Description-1",
    "Description2": "Description-2",
    "Value": "na",
    "Count": "Disabled",
    "Median": "Disabled",
    "Mode": "Disabled",
    "StdDev": "Disabled",
  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "6",
    "ParameterName": "Channel6",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "Enabled",
    "Min": "Enabled",
    "Max": "Enabled",
    "Avg": "Enabled",
    "MKT": "Enabled",
    "AssignedTag":"",
    "Description": "Channel-6",
    "Description1": "Description-1",
    "Description2": "Description-2",
    "Value": "na",
    "Count": "Disabled",
    "Median": "Disabled",
    "Mode": "Disabled",
    "StdDev": "Disabled",
  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "7",
    "ParameterName": "Channel7",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "Enabled",
    "Min": "Enabled",
    "Max": "Enabled",
    "Avg": "Enabled",
    "MKT": "Enabled",
    "AssignedTag":"",
    "Description": "Channel-7",
    "Description1": "Description-1",
    "Description2": "Description-2",
    "Value": "na",
    "Count": "Disabled",
    "Median": "Disabled",
    "Mode": "Disabled",
    "StdDev": "Disabled",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "8",
    "ParameterName": "Channel8",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "Enabled",
    "Min": "Enabled",
    "Max": "Enabled",
    "Avg": "Enabled",
    "MKT": "Enabled",
    "AssignedTag":"",
    "Description": "Channel-8",
    "Description1": "Description-1",
    "Description2": "Description-2",
    "Value": "na",
    "Count": "Disabled",
    "Median": "Disabled",
    "Mode": "Disabled",
    "StdDev": "Disabled",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "9",
    "ParameterName": "Channel9",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "Enabled",
    "Min": "Enabled",
    "Max": "Enabled",
    "Avg": "Enabled",
    "MKT": "Enabled",
    "AssignedTag":"",
    "Description": "Channel-9",
    "Description1": "Description-1",
    "Description2": "Description-2",
    "Value": "na",
    "Count": "Disabled",
    "Median": "Disabled",
    "Mode": "Disabled",
    "StdDev": "Disabled",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "10",
    "ParameterName": "Channel10",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "Enabled",
    "Min": "Enabled",
    "Max": "Enabled",
    "Avg": "Enabled",
    "MKT": "Enabled",
    "AssignedTag":"",
    "Description": "Channel-10",
    "Description1": "Description-1",
    "Description2": "Description-2",
    "Value": "na",
    "Count": "Disabled",
    "Median": "Disabled",
    "Mode": "Disabled",
    "StdDev": "Disabled",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "11",
    "ParameterName": "Channel11",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "Enabled",
    "Min": "Enabled",
    "Max": "Enabled",
    "Avg": "Enabled",
    "MKT": "Enabled",
    "AssignedTag":"",
    "Description": "Channel-11",
    "Description1": "Description-1",
    "Description2": "Description-2",
    "Value": "na",
    "Count": "Disabled",
    "Median": "Disabled",
    "Mode": "Disabled",
    "StdDev": "Disabled",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "12",
    "ParameterName": "Channel12",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "Enabled",
    "Min": "Enabled",
    "Max": "Enabled",
    "Avg": "Enabled",
    "MKT": "Enabled",
    "AssignedTag":"",
    "Description": "Channel-12",
    "Description1": "Description-1",
    "Description2": "Description-2",
    "Value": "na",
    "Count": "Disabled",
    "Median": "Disabled",
    "Mode": "Disabled",
    "StdDev": "Disabled",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "13",
    "ParameterName": "Channel13",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "Enabled",
    "Min": "Enabled",
    "Max": "Enabled",
    "Avg": "Enabled",
    "MKT": "Enabled",
    "AssignedTag":"",
    "Description": "Channel-13",
    "Description1": "Description-1",
    "Description2": "Description-2",
    "Value": "na",
    "Count": "Disabled",
    "Median": "Disabled",
    "Mode": "Disabled",
    "StdDev": "Disabled",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "14",
    "ParameterName": "Channel14",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "Enabled",
    "Min": "Enabled",
    "Max": "Enabled",
    "Avg": "Enabled",
    "MKT": "Enabled",
    "AssignedTag":"",
    "Description": "Channel-14",
    "Description1": "Description-1",
    "Description2": "Description-2",
    "Value": "na",
    "Count": "Disabled",
    "Median": "Disabled",
    "Mode": "Disabled",
    "StdDev": "Disabled",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "15",
    "ParameterName": "Channel15",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "Enabled",
    "Min": "Enabled",
    "Max": "Enabled",
    "Avg": "Enabled",
    "MKT": "Enabled",
    "AssignedTag":"",
    "Description": "Channel-15",
    "Description1": "Description-1",
    "Description2": "Description-2",
    "Value": "na",
    "Count": "Disabled",
    "Median": "Disabled",
    "Mode": "Disabled",
    "StdDev": "Disabled",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "16",
    "ParameterName": "Channel16",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "Enabled",
    "Min": "Enabled",
    "Max": "Enabled",
    "Avg": "Enabled",
    "MKT": "Enabled",
    "AssignedTag":"",
    "Description": "Channel-16",
    "Description1": "Description-1",
    "Description2": "Description-2",
    "Value": "na",
    "Count": "Disabled",
    "Median": "Disabled",
    "Mode": "Disabled",
    "StdDev": "Disabled",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "17",
    "ParameterName": "Description-1 Enable",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "na",
    "Description1": "na",
    "Description2": "na",
    "Value": "na",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "18",
    "ParameterName": "Description-2 Enable",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "na",
    "Description1": "na",
    "Description2": "na",
    "Value": "na",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "19",
    "ParameterName": "Total Row Enable",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "Total",
    "Description1": "na",
    "Description2": "na",
    "Value": "na",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "20",
    "ParameterName": "Min Row Enable",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "Min Value",
    "Description1": "na",
    "Description2": "na",
    "Value": "na",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "21",
    "ParameterName": "Max Row Enable",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "Max Value",
    "Description1": "na",
    "Description2": "na",
    "Value": "na",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "22",
    "ParameterName": "Avg Row Enable",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "Avg Value",
    "Description1": "na",
    "Description2": "na",
    "Value": "na",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "23",
    "ParameterName": "MKT Row Enable",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "MKT Value",
    "Description1": "na",
    "Description2": "na",
    "Value": "na",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "24",
    "ParameterName": "Count Row Enable",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "Total Count",
    "Description1": "na",
    "Description2": "na",
    "Value": "na",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",
  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "25",
    "ParameterName": "Median Row Enable",
    "Enable": "Disabled",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "Middle Value",
    "Description1": "na",
    "Description2": "na",
    "Value": "na",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",
  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "26",
    "ParameterName": "Mode Row Enable",
    "Enable": "Disabled",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "Frequently Occuring Value",
    "Description1": "na",
    "Description2": "na",
    "Value": "na",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",
  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "27",
    "ParameterName": "StdDev Row Enable",
    "Enable": "Disabled",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "Standard Deviation",
    "Description1": "na",
    "Description2": "na",
    "Value": "na",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",
  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "28",
    "ParameterName": "Main Header Enable",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "Main Header Enable or disable",
    "Description1": "na",
    "Description2": "na",
    "Value": "na",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",
  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "29",
    "ParameterName": "Sub Header Enable",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "Table-1 (Min, max ...etc) Enable or Disable",
    "Description1": "na",
    "Description2": "na",
    "Value": "na",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",
  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "30",
    "ParameterName": "Data Header Enable",
    "Enable": "Enabled",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "Table-2 Data header Enable or Disable",
    "Description1": "na",
    "Description2": "na",
    "Value": "na",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "31",
    "ParameterName": "Header Background Color",
    "Enable": "na",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "na",
    "Description1": "na",
    "Description2": "na",
    "Value": "1abd9c",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "32",
    "ParameterName": "Header FontWeight",
    "Enable": "na",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "na",
    "Description1": "na",
    "Description2": "na",
    "Value": "bold",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "33",
    "ParameterName": "FontSize",
    "Enable": "na",
    "Total": "na",
    "Repeatability":"na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "na",
    "Description1": "na",
    "Description2": "na",
    "Value": "7",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",

  },{
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "34",
    "ParameterName": "FontColor",
    "Enable": "na",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "na",
    "Description1": "na",
    "Description2": "na",
    "Value": "black",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "35",
    "ParameterName": "Landscape Mode - Record per Page",
    "Enable": "na",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "na",
    "Description1": "na",
    "Description2": "na",
    "Value": "12",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",

  },
  {
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "36",
    "ParameterName": "Portrait Mode - Record per Page",
    "Enable": "na",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "na",
    "Description1": "na",
    "Description2": "na",
    "Value": "25",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",

  },
{
    "ProjectName": props.projectName ,
    "DashboardType": "BatchData",
    "WidgetName": props.groupName,
    "SrNo": "37",
    "ParameterName": "Scale Factor - Record per Page",
    "Enable": "na",
    "Repeatability":"na",
    "Total": "na",
    "Min": "na",
    "Max": "na",
    "Avg": "na",
    "MKT": "na",
    "AssignedTag":"",
    "Description": "na",
    "Description1": "na",
    "Description2": "na",
    "Value": "1",
    "Count": "na",
    "Median": "na",
    "Mode": "na",
    "StdDev": "na",

  }];
  
  const [auditTrailData, setAuditTrailData] = React.useState([]);  // AuditTrail Data

  const [openRemarkBlnkMsg, setOpenRemarkBlnkMsg] = useState(false);
  const [password, setPassword] = useState('');
  const[pwdinterlock, setPwdInterlock] = useState("Disabled");

  const handleClickOpen = () => {
    if(((props.rowData.RemarkStatus === "Enabled") && (props.auditTrailRemark === "--")) || ((props.rowData.RemarkStatus === "Enabled") && (props.auditTrailRemark === ""))){
      setOpenRemarkBlnkMsg(true);
      //console.log("Enter or change the Remark value to proceed further")
    }else{
    setOpen(true);
    }
    
  };

  const handleClose = () => {
    setOpen(false);
    setOpenRemarkBlnkMsg(false);
  };

  const handleSuccessClose = () => {
    setOpenSuccessDialog(false);
    props.success(true);
  };

  const handleFildClose = () => {
    setOpenFaildialog(false);
  };
  

  const [message, setMessage] = useState();

  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openFaildialog, setOpenFaildialog] = useState(false);

  const [saveData, setSaveData] = useState(false);
  const handleClickSaveChanges = () => { 
    let oldValues = props.oldValues;
    let newValues = props.newValues;
    let groupName = props.groupName;
    let activity = props.activity;
    let activityType = 'Add Recipe Group';
    let userName = props.email;
    let role = props.role;
    let remark = props.auditTrailRemark;
    let eventStatus = props.rowData.EventStatus;
    //console.log(oldValues, newValues, groupName, activity, activityType, userName, role, remark, eventStatus)
    let auditTrailData = createAuditTrailData(oldValues, newValues, groupName, activity, activityType, userName, role, remark, eventStatus )
    //console.log(auditTrailData)
    setAuditTrailData(auditTrailData)
    setSaveData(true);
  };



const [groupNameList, setGroupNameList] = React.useState([]);
// Get GroupName list
 useEffect(() =>{
  async function getAllColumnData()  {
  try {
    let dashboardName = "RecipeGroupList"
    let columnName = "DashboardType"
    let columnValue = "RecipeView";

    const response = await RecipeService.getColumnData(dashboardName, columnName, columnValue);
    if (response){
      let GroupNames = response.data.map((item) => item.GroupName);
      setGroupNameList([...new Set(GroupNames)]); 
    }

  } catch (error) {
    console.log(error);

  }
};
  getAllColumnData();

}, []);


  //  Add new row to GrouptList
  useEffect(() =>{
    async function saveRowData()  {
    try {

      let dashboardName = "RecipeGroupList"
      //let rowData = props.rowData; // It should inclue all three field ie ProjectName, DashboardType, GroupName
      let rowData = {...props.rowData, PWDInterlock: props.rowData.PWDInterlock, PWD: password};
      // Tag name & DataField Duplcation check for new tag
      if (groupNameList.includes(rowData.GroupName)) {
        setOpenFaildialog(true);
        setMessage("Group Name already exist. Choose different Group name to avoid duplication.");
        setSaveData(false);
        setOpen(false); // Close "Save changes" window

      }else{
        // Blank value check for the  one of the form field
        if (rowData.GroupName === '') {
          setOpenFaildialog(true);
          setMessage("Group Name field is blank, please correct it.");
          setSaveData(false);
          setOpen(false); // Close "Save changes" window

        } else {
            const response = await RecipeService.createRow(dashboardName, rowData, auditTrailData);  // create new record if id is not present in array data ie existing data
            if(response){
              let dashboardName= "BatchReportConfig"
              const response1 = await BatchDataService.insertMultipleRow(dashboardName, widgetConfigData);  // Insert multiple records
              if(response1){              
                setOpenSuccessDialog(true);
                setMessage("Record Added Successfully, Reload the application to get new widget name list.");
                setSaveData(false);
                setOpen(false); // Close "Save changes" window
              }
            }
        }
      }

    } catch (error) {
      setOpenFaildialog(true);
      setMessage("Error While Adding Record, Please very all parameters entered in form");
      setOpen(false); // Close "Save changes" window
      console.log(error);


    }
  };
  if(saveData){
    saveRowData();
    setSaveData(false);
  };


  }, [saveData]);

 
  

  return (
    
    <div>
      <Button variant="outlined" startIcon ={<SaveIcon/>} sx={{mt:1}} onClick={handleClickOpen}>SAVE CHANGES </Button>

      {/* Open Remark Field is blank dialog box */}
      <Dialog open={openRemarkBlnkMsg} onClose={handleClose}>
        <DialogTitle>Enter Remark Field</DialogTitle>
        <Box sx={{width: 450 }}>
        <DialogContent dividers>
          <DialogContentText>
              Enter or change the Remark Field to proceed further.
              <br />
              (Note: '--' Value for remark field is not acceptable)
          </DialogContentText>
          
        </DialogContent>
        </Box>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* Open Dialog to ask surity to edit user's data, with or withoout password */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>SAVE CHANGES</DialogTitle>
        <Box sx={{width: 400 }}>
        <DialogContent dividers>
          <DialogContentText>
            Are you sure to add new group.
          </DialogContentText>
          
        </DialogContent>

        {props.rowData.PWDInterlock === 'Enabled' && (<DialogContent dividers>
          <DialogContentText>
            Enter the Password to add new recipe.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="Password"
            label="Password"
            type="password"
            fullWidth
            variant="standard"
            onChange={(event) => {
              setPassword(event.target.value);
            }}
          />

          </DialogContent>
        )}

        </Box>
        <DialogActions>
          <Button onClick={handleClickSaveChanges}>Save</Button>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* Success dialog after upgradtion of teh user info. */}
      <Dialog
        open={openSuccessDialog}
        onClose={handleSuccessClose}
       
      >
        <DialogTitle > success.. </DialogTitle>
        <DialogContent>
          <DialogContentText>
            { message } 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSuccessClose}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Save Changes Failed dialog /Wrong Password */}
      <Dialog
        open={openFaildialog}
        onClose={handleFildClose}
       
      >
        <DialogTitle > Failed.. </DialogTitle>
        <DialogContent>
          <DialogContentText>
            { message } 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFildClose}>Close</Button>
        </DialogActions>
      </Dialog>


    </div>
  );
}


export default function AlarmGroupListAdd ({open, close}) {
  const { user } = useSelector((state) => state.auth);
  const projectName = user.selectedproject;
  const dashboardType = 'RecipeView';
  const [widgetName, setWidgetname] = useState("")

  //console.log(ProjectName, DashboardType);


  const initialAlarmConfigData = {
    //id: null,
    ProjectName: projectName ,
    DashboardType: dashboardType,
    GroupName: "",
    GroupDescription: "",

    email: user.email,
    role: user.role,  
    RemarkStatus : "Disabled",
    EventStatus:"Disabled",
    PWDInterlock:"Disabled",
            
  };

  const [eventDescription, setEventDescription] = useState("--");
  const [auditTrailRemark, setAuditTrailRemark] = useState("--");
  // parameter list for audit trail log
  const oldValues = {GroupName: "", GroupDescription:"",};

  const [newValues, setNewValues] = useState(oldValues);

  const [recipeListData, setRecipeListData] = React.useState(initialAlarmConfigData);

  // Get AuditTrail Configuration data for Remark field, either it is enabled or disabled
  useEffect(() =>{
    async function auditTrailConfigData()  {
    try {

      let dashboardName = 'AuditTrailConfig';
      let columnName = 'EventName';
      let columnValue = 'Add Dashboard Group';
      let response = await AuditTrailViewService.getColumnData(dashboardName, columnName, columnValue);

      //console.log(response.data[0].EnableRemark);
      if(response.data.length > 0){
        setRecipeListData({...recipeListData, EventStatus: response.data[0].EnableEvent, PWDInterlock: response.data[0].EnablePwdInterlock, RemarkStatus: response.data[0].EnableRemark});

        setEventDescription(response.data[0].DefaultEventDescription);
        // If remark field is disabled then set default remark vlaue to currrent Remark value
        if(response.data[0].EnableRemark === "Disabled"){
          setAuditTrailRemark(response.data[0].DefaultEventRemark);
        }
        
      }
  
    } catch (error) {
      console.log(error);

    }
  }

  auditTrailConfigData();

  }, []);

 
  const handleClose = () => {
    //console.log("Close Buton Pressed");
    close() // Close the alarm add main window
  };

  const handleRecordSaveSuccess = (data) =>{
    close(data)
  }

  const handleTextFieldChange = (event) => {

    const {name, value} = event.target;
    setRecipeListData({...recipeListData, [name]:value});
    setNewValues ({...newValues, [name] :value});

    setWidgetname(event.target.value);
  };

  const handleRemarkChange = (event) => {
    const {name, value} = event.target;
    if(recipeListData.RemarkStatus === "Enabled"){
      setAuditTrailRemark(value);

    }
  };

  return (
    <div>
      
      <BootstrapDialog
        onClose={close}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          style: {
            maxWidth: '1000px', // Change this value as needed
          },
        }}
      >
        {/* Hnadle multiple functions on single click ie edit switch set to false and close the MyAccount Dialog */}
        <BootstrapDialogTitle id="customized-dialog-title" onClose={() => {handleClose();  }}>
          Add new group to the List.
        </BootstrapDialogTitle>

        {/*Group Name setting */}
        <DialogContent dividers>
          

          {/* ProjectName */}
          <TextField
            autoFocus
            margin="dense"
            label="ProjectName"
            type="text"
            fullWidth
            variant="standard"
            name="ProjectName"
            value={projectName}
            onChange={handleTextFieldChange}
            disabled={true}
          />

          {/* DashboardType */}
          <TextField
            autoFocus
            margin="dense"
            label="DashboardType"
            type="text"
            fullWidth
            variant="standard"
            name="DashboardType"
            value={dashboardType}
            onChange={handleTextFieldChange}
            disabled={true}
          />

          {/* GroupName */}
          <TextField
            autoFocus
            margin="dense"
            label="Group Name"
            type="text"
            fullWidth
            variant="standard"
            name="GroupName"
            value={recipeListData.GroupName}
            onChange={handleTextFieldChange}
            disabled={false}
          />


          {/* GroupDescription */}
          <TextField
            autoFocus
            margin="dense"
            label="Group Description"
            type="text"
            fullWidth
            variant="standard"
            name="GroupDescription"
            value={recipeListData.GroupDescription}
            onChange={handleTextFieldChange}
            disabled={false}
          />

        </DialogContent>

         {/*Remark */}
         {recipeListData.RemarkStatus === 'Enabled' && (<DialogContent 
        dividers
        >
          <Typography gutterBottom sx={{ mt: 0, mb:3, width: 400 }}>
          Enter remark/reason 
          </Typography>

          <TextField
            id="outlined-multiline-static"
            label="Remark"
            name="Remark"
            placeholder="Enter Remark"
            multiline
            rows={2}
            style={{ width: 550 }}
            onChange={handleRemarkChange}
            //defaultValue="Default Value"
          />

        </DialogContent>
        )}


        <DialogActions>
          <SaveChangesDialog
          projectName = {projectName}
          dashboardType = {dashboardType}
          widgetName = {widgetName}
          rowData = {recipeListData}

          email = {user.email}
          role = {user.role}
          oldValues = {oldValues}
          newValues = {newValues}
          activity = {eventDescription}
          groupName = {recipeListData.GroupName}
          auditTrailRemark = {auditTrailRemark}

          success = {handleRecordSaveSuccess}
          />
        </DialogActions>
        
      </BootstrapDialog>
    </div>
  );
}



